/** @format */

export const StarLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.9997 24.9081L25.0637 30.6666L22.6583 19.8133L30.6663 12.5109L20.121 11.5691L15.9997 1.33331L11.8783 11.5691L1.33301 12.5109L9.34101 19.8133L6.93567 30.6666L15.9997 24.9081Z"
                fill={color}
            />
        </svg>
    );
};
